import common from './zh-TW/common.js';
import intro from './zh-TW/intro';
import login from './zh-TW/login';
import memberWine from './zh-TW/member-wine';
import order from './zh-TW/order';
import register from './zh-TW/register';
import shipping from './zh-TW/shipping';
import verify from './zh-TW/verify';
import wineList from './zh-TW/wine-list';

const i18n = {
	...common,
	...intro,
	...login,
	...memberWine,
	...order,
	...register,
	...shipping,
	...verify,
	...wineList,
}

export default i18n